import { Button } from "agronomist-ui-components";
import Cookies from "js-cookie";
import { path } from "ramda";
import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import Modal from "react-modal";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { compose } from "recompose";
import { addPhoto } from "../../../services/redux/photos/reducer";
import { ReactComponent as XIcon } from "../../svg-icons/x.svg";
import LoginForm from "../LoginForm/LoginForm";
import { AddFiledForm, AddFiledImage } from "../ShowOffField/Components";
import "./AddPhotoButton.scss";

const AddPhotoButton = ({ t, className, userIsLogin, history, addPhoto }) => {
  const [showAddPhoto, setShowAddPhoto] = useState(false);
  const [showLogin, setShowLogin] = useState(false);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (showAddPhoto || showLogin) {
      document.querySelector("body").style.overflowY = "hidden";
    } else {
      document.querySelector("body").style.overflowY = "scroll";
    }
  }, [showAddPhoto, showLogin]);

  const onSubmit = e => {
    e.preventDefault();
    const formData = new FormData(e.target);
    setErrors({});
    const errors = {};
    // eslint-disable-next-line no-restricted-syntax
    for (const [key, value] of formData) {
      if (key === "image") {
        const error = value.size === 0 && "Pole wymagane";
        if (error) {
          errors[key] = error;
        }
      } else if (!value) {
        errors[key] = "Pole wymagane";
      }
    }
    if (Object.keys(errors).length) {
      setErrors(errors);
      return;
    }
    addPhoto(formData)
      .then(() => {
        setShowAddPhoto(false);
        Cookies.set("photo-uploaded", true, { secure: true });
        history.push("/galeria");
      })
      .catch(e => {
        const { error } = e || {};
        const errorsList = path(["response", "data"], error);
        if (errorsList) {
          setErrors(errorsList);
        }
      });
  };

  return (
    <>
      <Button
        type="button"
        className={`btn-add-photo ${className?className:""}`}
        onClick={() =>
          userIsLogin ? setShowAddPhoto(true) : setShowLogin(true)
        }
      >
        {t("widgets:photo.add")}
      </Button>
      <Modal
        isOpen={showLogin}
        onRequestClose={() => setShowLogin(false)}
        style={{
          overlay: {
            zIndex: "1000",
            backgroundColor: "rgba(0,0,0,0.6)",
          },
          content: {
            width: "100%",
            maxWidth: "670px",
            margin: "0 auto",
            bottom: "unset",
            borderRadius: 0,
            padding: 0,
            overflowX: "hidden",
            backgroundColor: "#ffffff",
          },
        }}
      >
        <div className="modal__login">
          <div className="modal__login__text">
            {t("widgets:popup.altLogin")}
          </div>
          <LoginForm
            onLoginCallback={() => {
              setShowLogin(false);
              setShowAddPhoto(true);
            }}
          />
        </div>
      </Modal>
      <Modal
        isOpen={showAddPhoto}
        onRequestClose={() => setShowAddPhoto(false)}
        style={{
          overlay: {
            zIndex: "1000",
            backgroundColor: "rgba(0,0,0,0.6)",
            overflowY: "scroll",
          },
          content: {
            maxWidth: "1170px",
            margin: "0 auto 40px auto",
            bottom: "unset",
            borderRadius: 0,
            padding: 0,
            overflowX: "hidden",
            backgroundColor: "#ffffff",
            left: 20,
            right: 20,
          },
        }}
      >
        <div className="modal__content">
          <h2>{t("widgets:photo.add")}</h2>
          <form onSubmit={onSubmit}>
            <AddFiledImage errors={errors} />
            <div className="modal__meta">
              <AddFiledForm errors={errors} />
            </div>
          </form>
        </div>
        <button
          type="button"
          className="modal__close"
          onClick={() => setShowAddPhoto(false)}
        >
          <XIcon />
        </button>
      </Modal>
    </>
  );
};

AddPhotoButton.propTypes = {};
AddPhotoButton.defaultProps = {};

export default compose(
  withTranslation(["widgets"]),
  connect(
    state => ({
      userIsLogin: state.user.token !== "",
    }),
    {
      addPhoto,
    }
  ),
  withRouter
)(AddPhotoButton);
